import { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import Button from "./ui/Button";

const Navbar: React.FC = () => {
  const { isAuthenticated, loginWithRedirect, logout, user } = useAuth0();
  const [open, setOpen] = useState(false);

  return (
    <nav className="sticky top-0 z-30 border-b border-primary-100/70 bg-paper/80 backdrop-blur-md">
      <div className="mx-auto max-w-5xl px-4 sm:px-6">
        <div className="flex h-16 items-center justify-between">
          <Link to="/" className="group flex items-center gap-2.5">
            <img
              src="/logo.svg"
              alt="Kinoes"
              className="h-9 w-9 transition-transform duration-300 group-hover:-rotate-6"
            />
            <span className="font-display text-2xl font-semibold tracking-tight text-ink">Kinoes</span>
          </Link>

          {/* Desktop */}
          <div className="hidden items-center gap-3 sm:flex">
            {isAuthenticated && (
              <Link
                to="/dashboard"
                className="rounded-full px-3 py-2 text-sm font-medium text-ink/70 transition-colors hover:bg-ink/5 hover:text-ink"
              >
                Families
              </Link>
            )}
            {isAuthenticated ? (
              <div className="flex items-center gap-3">
                <span className="hidden text-sm text-ink/55 md:inline">{user?.name || user?.email}</span>
                <Button
                  variant="secondary"
                  onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
                >
                  Sign out
                </Button>
              </div>
            ) : (
              <Button onClick={() => loginWithRedirect()}>Sign in</Button>
            )}
          </div>

          {/* Mobile toggle */}
          <button
            onClick={() => setOpen(!open)}
            className="inline-flex items-center justify-center rounded-md p-2 text-ink/70 hover:bg-ink/5 sm:hidden"
            aria-label="Toggle menu"
          >
            <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="space-y-2 border-t border-primary-100/70 bg-paper px-4 py-3 sm:hidden">
          {isAuthenticated && (
            <Link
              to="/dashboard"
              onClick={() => setOpen(false)}
              className="block py-2 text-base font-medium text-ink/80 hover:text-ink"
            >
              Families
            </Link>
          )}
          {isAuthenticated ? (
            <Button
              variant="secondary"
              fullWidth
              onClick={() => {
                logout({ logoutParams: { returnTo: window.location.origin } });
                setOpen(false);
              }}
            >
              Sign out
            </Button>
          ) : (
            <Button
              fullWidth
              onClick={() => {
                loginWithRedirect();
                setOpen(false);
              }}
            >
              Sign in
            </Button>
          )}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
